var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneyHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(0.5)",
    fill: "white",
    fillOpacity: 0.01,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 1.5H17.75V3H21.5V21H17.75V22.5H21.5C22.325 22.5 23 21.825 23 21V3C23 2.175 22.325 1.5 21.5 1.5Z",
    fill: "#0092C6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 15.39C17.75 11.925 14.915 11.535 12.635 11.22C10.1525 10.875 8.75 10.575 8.75 8.4375C8.75 6.645 10.6325 6.0075 12.2375 6.0075C13.9775 6.0075 15.3425 6.6525 16.415 7.98L17.585 7.035C16.445 5.625 14.99 4.8075 13.25 4.575V2.25H11.75V4.515C9.035 4.68 7.25 6.21 7.25 8.43C7.25 11.9775 10.1225 12.375 12.4325 12.6975C14.87 13.035 16.25 13.3275 16.25 15.3825C16.25 17.655 13.9025 17.9925 12.5 17.9925C9.9275 17.9925 8.84 17.2725 7.835 16.02L6.665 16.965C7.9925 18.6075 9.4625 19.3425 11.75 19.47V21.75H13.25V19.47C16.0475 19.245 17.75 17.7225 17.75 15.39Z",
    fill: "#0092C6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 3H7.25V1.5H3.5C2.675 1.5 2 2.175 2 3V21C2 21.825 2.675 22.5 3.5 22.5H7.25V21H3.5V3Z",
    fill: "#0092C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyHome);
export default __webpack_public_path__ + "static/media/moneyHome.d3a48959acafe22103fb17af5ee73e6b.svg";
export { ForwardRef as ReactComponent };